import { Directive, HostBinding, inject, Input } from '@angular/core';
import { MatIcon, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'mat-icon[icon]', standalone: true })
export class IconDirective {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly matIcon = inject(MatIcon, { host: true });

  @Input() public iconSize = 14;
  @Input() public iconWidth: number;
  @Input() public iconHeight: number;

  @Input() public set icon(icon: string) {
    const iconPath = this.sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`);
    this.matIconRegistry.getNamedSvgIcon(icon).subscribe({ error: () => this.matIconRegistry.addSvgIcon(icon, iconPath) });
    this.matIcon.svgIcon = icon;
  }

  @HostBinding('style.width.px')
  @HostBinding('style.min-width.px')
  public get iconStyleWidth(): number {
    return this.iconWidth ?? this.iconSize;
  }

  @HostBinding('style.height.px')
  @HostBinding('style.min-height.px')
  public get iconStyleHeight(): number {
    return this.iconHeight ?? this.iconSize;
  }

  @HostBinding('class.tt-icon') public iconClass = true;
}
